var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4023 8.19525C13.4023 9.51559 14.4727 10.5859 15.793 10.5859H23C23.5523 10.5859 24 11.0337 24 11.5859C24 12.1382 23.5523 12.5859 23 12.5859H15.793C14.4727 12.5859 13.4023 13.6563 13.4023 14.9766V23C13.4023 23.5523 12.9546 24 12.4023 24C11.8501 24 11.4023 23.5523 11.4023 23V14.9766C11.4023 13.6563 10.332 12.5859 9.01166 12.5859H1C0.447715 12.5859 0 12.1382 0 11.5859C0 11.0337 0.447715 10.5859 1 10.5859H9.01166C10.332 10.5859 11.4023 9.51559 11.4023 8.19525V1C11.4023 0.447715 11.8501 0 12.4023 0C12.9546 0 13.4023 0.447715 13.4023 1V8.19525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.b2025197e72756770e513d196c56798b.svg";
export { ForwardRef as ReactComponent };